const SUGGESTION_MENU_MAX_PX = 272; // 17rem
const DROPDOWN_GAP_PX = 4;
const PORTAL_Z_INDEX = 220;

let activeReposition = null;

function getSuggestionMenuEl(optionsContainer) {
    if (!optionsContainer) return null;
    const menu = optionsContainer.firstElementChild;
    if (!menu || menu.id === 'loadingIcon') return null;
    return menu;
}

function getFormBounds(target) {
    const formRoot = target.closest('[data-form-root]');
    if (!formRoot) {
        return { top: 8, bottom: window.innerHeight - 8 };
    }
    const rect = formRoot.getBoundingClientRect();
    return { top: rect.top + 8, bottom: rect.bottom - 8 };
}

export function positionSuggestionMenuFixed(target, optionsContainer) {
    const menu = getSuggestionMenuEl(optionsContainer);
    if (!menu || !target) return;

    const inputRect = target.getBoundingClientRect();
    const { top: formTop, bottom: formBottom } = getFormBounds(target);

    const spaceBelow = formBottom - inputRect.bottom - DROPDOWN_GAP_PX;
    const spaceAbove = inputRect.top - formTop - DROPDOWN_GAP_PX;
    const openDown = spaceBelow >= 80 || spaceBelow >= spaceAbove;

    menu.classList.add('suggestion-menu-portal');
    menu.style.position = 'fixed';
    menu.style.left = `${inputRect.left}px`;
    menu.style.width = `${inputRect.width}px`;
    menu.style.zIndex = String(PORTAL_Z_INDEX);
    menu.style.marginTop = '0';

    if (openDown) {
        menu.style.top = `${inputRect.bottom + DROPDOWN_GAP_PX}px`;
        menu.style.bottom = 'auto';
        menu.style.maxHeight = `${Math.min(SUGGESTION_MENU_MAX_PX, Math.max(spaceBelow, 96))}px`;
    } else {
        menu.style.bottom = `${window.innerHeight - inputRect.top + DROPDOWN_GAP_PX}px`;
        menu.style.top = 'auto';
        menu.style.maxHeight = `${Math.min(SUGGESTION_MENU_MAX_PX, Math.max(spaceAbove, 96))}px`;
    }
}

export function resetSuggestionMenuPosition(optionsContainer) {
    const menu = getSuggestionMenuEl(optionsContainer);
    if (!menu) return;
    menu.classList.remove('suggestion-menu-portal');
    menu.style.position = '';
    menu.style.top = '';
    menu.style.bottom = '';
    menu.style.left = '';
    menu.style.width = '';
    menu.style.maxHeight = '';
    menu.style.zIndex = '';
    menu.style.marginTop = '';
}

function detachSuggestionRepositionListeners() {
    if (!activeReposition) return;
    activeReposition.content?.removeEventListener('scroll', activeReposition.handler);
    window.removeEventListener('resize', activeReposition.handler);
    activeReposition = null;
}

function attachSuggestionRepositionListeners(target, optionsContainer) {
    detachSuggestionRepositionListeners();
    const handler = () => {
        if (!optionsContainer || optionsContainer.style.display === 'none') return;
        positionSuggestionMenuFixed(target, optionsContainer);
    };
    const content = target.closest('.formContent');
    content?.addEventListener('scroll', handler, { passive: true });
    window.addEventListener('resize', handler, { passive: true });
    activeReposition = { handler, content };
}

function shouldUsePortalPosition(target) {
    return !!target?.closest('.formContent');
}

export function showSuggestionsDropdown(target, column, optionsContainer) {
    if (!optionsContainer) return;
    optionsContainer.style.display = 'block';
    if (!shouldUsePortalPosition(target)) return;

    const applyPosition = () => {
        if (optionsContainer.style.display === 'none') return;
        positionSuggestionMenuFixed(target, optionsContainer);
    };
    applyPosition();
    requestAnimationFrame(applyPosition);
    attachSuggestionRepositionListeners(target, optionsContainer);
}

export function hideSuggestionsDropdown(target, optionsContainer) {
    if (!optionsContainer) return;
    optionsContainer.style.display = 'none';
    resetSuggestionMenuPosition(optionsContainer);
    if (target && shouldUsePortalPosition(target)) {
        detachSuggestionRepositionListeners();
    }
}
